import { DisplayOnlyField } from "components/Forms/DisplayOnlyField";
import { FormSelect } from "components/Forms/FormSelect";
import { Country } from "generated-graphql/graphql";
import { useValidatingFormContext } from "hooks/useValidatingForm";
import { ComponentProps } from "react";

type Props = Omit<ComponentProps<typeof FormSelect>, "label" | "selectItems">;

export const CountryPicker = (props: Props) => {
  const formContext = useValidatingFormContext();
  if (formContext?.metadata?.isDisplayOnly) {
    return (
      <DisplayOnlyField
        text={formContext?.getValues(props.name) ?? props.defaultValue ?? ""}
        label={"Country"}
      />
    );
  }

  return (
    <FormSelect
      {...props}
      label="Country"
      selectItems={[
        { value: Country.Usa, display: "United States" },
        { value: Country.Canada, display: "Canada" },
      ]}
    />
  );
};
